import { render, staticRenderFns } from "./CargoAnalysis.vue?vue&type=template&id=0de8671b"
import script from "./CargoAnalysis.vue?vue&type=script&lang=js"
export * from "./CargoAnalysis.vue?vue&type=script&lang=js"
import style0 from "./CargoAnalysis.vue?vue&type=style&index=0&id=0de8671b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports